import { cloneDeep } from 'lodash';
import { useForm } from 'react-hook-form';

export default function useEnochConfigForm() {
  return useForm({
    defaultValues: cloneDeep(enochConfigDefaultValues),
    mode: 'onBlur',
  });
}

export const enochConfigDefaultValues = {
  useDefaultConfig: true,
  userDataDir: '',
  subjects: [],
  domains: [],
  sendCountConfig: {
    unlimited: 1,
    count: 0,
  },
  cron: undefined,
  waitTime: {
    from: 2,
    to: 3,
  },
  shouldMoveOutOfPromotion: true,
  shouldEngageNewsletters: false,
  shouldMoveOutOfSpam: true,
  restartCycleAfterFinish: {
    enabled: true,
    count: 0,
    delay: 60 * 10, // 10 min
  },
  defaultRates: {
    click: 50,
    open: 70,
    reply: 51,
  },
  profiles: [],
};
